module.exports = __webpack_public_path__ + "static/media/district.5706fe10.jpeg";